module.exports = __webpack_public_path__ + "img/GALLERY-CIAZ-5.d6adfbc3.jpg";